export function AttachIcon({ ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      id='Icon_ionic-ios-attach'
      data-name='Icon ionic-ios-attach'
      xmlns='http://www.w3.org/2000/svg'
      width='8.248'
      height='16'
      viewBox='0 0 8.248 16'
      {...props}
    >
      <path
        id='Icon_ionic-ios-attach-2'
        data-name='Icon ionic-ios-attach'
        d='M17.567,6.86a.558.558,0,0,0-.557.557v6.941a2.879,2.879,0,0,1-.786,1.967,2.826,2.826,0,0,1-1.982.846h-.486a2.775,2.775,0,0,1-1.957-.878,2.867,2.867,0,0,1-.853-1.971V5.367a1.941,1.941,0,0,1,.618-1.41,2.125,2.125,0,0,1,1.464-.582,1.987,1.987,0,0,1,2.007,1.992V13.73A1.129,1.129,0,0,1,14,14.879a1.1,1.1,0,0,1-1.007-1.15V8.959a.557.557,0,1,0-1.114,0v4.77a2.142,2.142,0,0,0,3.646,1.607,2.255,2.255,0,0,0,.625-1.607V5.367A3.121,3.121,0,0,0,13.018,2.25a3.133,3.133,0,0,0-2.221.911,3.081,3.081,0,0,0-.925,2.21v8.955a3.99,3.99,0,0,0,1.164,2.785,3.86,3.86,0,0,0,2.717,1.139h.486a3.9,3.9,0,0,0,2.71-1.146,4.011,4.011,0,0,0,.853-1.235,3.738,3.738,0,0,0,.318-1.5V7.417A.552.552,0,0,0,17.567,6.86Z'
        transform='translate(-9.872 -2.25)'
        fill='currentColor'
      />
    </svg>
  )
}
